import React from "react";
import styles from "./style.module.scss";
import classNames from "classnames";
import { ResetZoomIcon, ZoomInIcon, ZoomOutIcon } from "./Icons";

interface ZoomControlProps {
  maxZoom: number;
  zoomLevel: number;
  className?: string;
  onZoomLevelChange: (zoomLevel: number) => void;
  onCenterImageClick: () => void;
}

const ZoomControl = ({
  maxZoom,
  zoomLevel,
  onZoomLevelChange,
  onCenterImageClick,
  className,
}: ZoomControlProps) => {
  const handleMinusClick = () => {
    onZoomLevelChange(Math.max(100, zoomLevel - 10));
  };

  const handlePlusClick = () => {
    onZoomLevelChange(Math.min(maxZoom, zoomLevel + 10));
  };

  const handleResetClick = () => {
    onZoomLevelChange(100);
    onCenterImageClick();
  };

  return (
    <div className={classNames(styles.zoomControl, className)}>
      <div className={styles.zoomIcon} onClick={handlePlusClick}>
        <ZoomInIcon />
      </div>
      <div className={styles.zoomIcon} onClick={handleMinusClick}>
        <ZoomOutIcon />
      </div>
      <div className={styles.zoomIcon} onClick={handleResetClick}>
        <ResetZoomIcon />
      </div>
    </div>
  );
};

export default ZoomControl;
